<button class="sidebar-minimizer" type="button" appSidebarMinimizer appBrandMinimizer></button>



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html